import { hotList } from "@/mocks/nanaData";

const trendIcon: Record<string, { icon: string; cls: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "text-primary-500" },
  new: { icon: "ri-fire-fill", cls: "text-primary-500" },
  down: { icon: "ri-arrow-down-line", cls: "text-secondary-600" },
  keep: { icon: "ri-arrow-right-line", cls: "text-foreground-400" },
};

export default function HotList() {
  return (
    <section id="hot" className="px-4 py-14 md:px-6 md:py-16" aria-label="实时热搜风向">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
          <div>
            <span className="text-xs font-semibold uppercase tracking-widest text-primary-500">实时热搜风向</span>
            <h2 className="mt-2 font-[ZCOOL_KuaiLe] text-3xl text-foreground-950">今日热门 TOP 10</h2>
            <p className="mt-2 text-sm text-foreground-500">汇总各平台当前讨论最热的话题，箭头实时反映热度变化。</p>
          </div>
          <span className="flex items-center gap-1.5 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1.5 text-xs text-secondary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-secondary-500 opacity-75"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-secondary-500"></span>
            </span>
            刚刚更新
          </span>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-3 lg:grid-cols-2">
          {hotList.map((item) => {
            const t = trendIcon[item.trend];
            return (
              <div
                key={item.rank}
                className="flex cursor-pointer items-center gap-4 rounded-2xl border border-background-200 bg-background-50 px-4 py-3.5 transition-colors hover:border-primary-200 hover:bg-background-100"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg font-[ZCOOL_KuaiLe] text-lg ${
                    item.rank <= 3 ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-500"
                  }`}
                >
                  {item.rank}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-medium text-foreground-800">{item.title}</p>
                  <p className="mt-1 text-xs text-foreground-400">
                    <span className="rounded bg-secondary-100 px-1.5 py-0.5 text-secondary-700">{item.platform}</span>
                    <span className="ml-2">热度 {item.heat}</span>
                  </p>
                </div>
                <span className={`flex items-center gap-0.5 whitespace-nowrap text-xs ${t.cls}`}>
                  <i className={t.icon}></i>
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}